export const SET_PREV_PATH = 'SET_PREV_PATH';
export const CLEAR_STATE = 'CLEAR_STATE';
